export { default as Image } from "./Image";
export { default as BackgroundImage } from "./BackgroundImage";
export { default as Logo } from "./Logo";
export { default as MenuBurger } from "./MenuBurger";
export { default as Slider } from "./Slider";
export { default as WithTitle } from "./WithTitle";
export { default as ClickMove } from "./ClickMove";
export { default as StepsToGetQuote } from "./StepsToGetQuote";
export { default as Footer } from "./Footer";
export { default as Maps } from "./Maps";
export { default as TipsTrendsItem } from "./TipsTrendsItem";
export { default as LanguageSwitcher } from "./LanguageSwitcher";
export { default as ScrollToTop } from "./ScrollToTop";
export { default as LoginForm } from "./Form/LoginForm";
export { default as LogoutForm } from "./Form/LogoutForm";
export { default as RegisterForm } from "./Form/RegisterForm";
export { default as QuoteForm } from "./Form/QuoteForm";
export { default as WishlistForm } from "./Form/WishlistForm";
export { default as ContactForm } from "./Form/ContactForm";
export { default as JoinUsForm } from "./Form/JoinUsForm";
export { default as ProductItem } from "./ProductItem";
export { default as Search } from "./Search";
export { default as MainSlider } from "./MainSlider";
export { default as PopularProducts } from "./PopularProducts";
export { default as PopularTipsTrends } from "./PopularTipsTrends";
export { default as Header } from "./Header";
export { default as SocialList } from "./SocialList";
export { default as SliderArrow } from "./SliderArrow";
export { default as Spin } from "./Spin";



// WEBPACK FOOTER //
// ./src/components/index.js